import * as Yup from 'yup';

export default Yup.object().shape({
  username: Yup.string().min(2, 'Too short!').max(100, 'Too long!').required('Please enter valid username'),
  password: Yup.string().min(1, 'Too short!').max(100, 'Too long!').required('Please enter password')
});
